module.exports = __webpack_public_path__ + "img/user-with-cap.e95924f5.svg";